"use client";

import { useEffect } from "react";

/**
 * Único componente de cliente del sitio. El marcado es estático (servidor);
 * aquí solo se cargan los módulos de interacción, en un fragmento aparte y después del primer pintado.
 */
export function Interactions() {
  useEffect(() => {
    void import("@/interactions").then((m) => m.initInteractions());
  }, []);
  return null;
}
